/**
 * @fileoverview Org portal — Settings → Schedule (/org/settings/schedule).
 *
 * The organization's time zone (OrgTimezoneCard), which every class without a
 * program address meets in, then its Kalver Scheduler connection: setting the business up,
 * linking an administrator's personal profile, opening Scheduler, recording
 * consent at booking and the connected classes, with Calendar sync (Spec 19)
 * under the time zone. It used to sit under the old
 * dashboard's numbers; it is set up once and then read approximately never,
 * so it belongs with the other settings. The Calendar page links straight
 * here as "Scheduling preferences".
 */

import { useContext } from "react";
import { OrgAuthContext } from "@/App";
import SchedulingSection from "@/components/settings/SchedulingSection";
import CalendarSyncSection from "@/components/settings/CalendarSyncSection";
import OrgTimezoneCard from "@/components/org/OrgTimezoneCard";
import { Card } from "@/components/studio/primitives";
import { calendarSyncFlags } from "@/lib/featureFlags";
import orgApi from "@/lib/orgApi";

export default function OrgSchedulePage() {
  const { flags } = useContext(OrgAuthContext) || {};
  return (
    <div data-testid="org-schedule-page">
      <h1 className="mb-2 font-serif text-2xl font-semibold text-[var(--text-primary)]">Schedule</h1>
      <p className="mb-6 font-sans text-[13px] text-[var(--text-tertiary)]">
        Class meetings and bookings live in Kalver Scheduler. Services, hours and payment settings open in Scheduler
        itself.
      </p>
      <div className="mb-6">
        <OrgTimezoneCard />
      </div>
      <CalendarSyncSection
        portal="org"
        client={orgApi}
        prefix="/org"
        available={calendarSyncFlags({ flags })}
        className="mb-8"
      />
      <SchedulingSection
        organization
        title={null}
        unavailable={
          <Card data-testid="org-schedule-unavailable">
            <p className="font-sans text-[15px] text-[var(--text-secondary)]">
              Scheduling isn&rsquo;t available for your organization yet.
            </p>
            <p className="mt-1 font-sans text-[13px] text-[var(--text-tertiary)]">
              When it is, you&rsquo;ll connect your Kalver Scheduler business here.
            </p>
          </Card>
        }
      />
    </div>
  );
}
